import {
  Box,
  Container,
  Header,
  SpaceBetween,
  Link,
  Tabs,
} from "@amzn/awsui-components-react";
import { Modernizations, ServiceItem } from "../../calcBusterTypes";
import PathwaysBarChart from "./PathwaysBarChart";
import ModernServicesTable from "./ModernServicesTable";
import config from "../../config";

const ModernizationSection = (
  modernizations: Modernizations,
  services: ServiceItem[]
) => {
  const modernizationServicesContainer = () => {
    return (
      <SpaceBetween size="l">
        <Box>
          <b>Modern services</b> are services that belong to at least one
          Modernization Pathway. The list of services is available{" "}
          <Link href={config.MODERNIZATION_PATHS}>here</Link>
        </Box>

        <Tabs
          tabs={[
            {
              label: "Modern Services",
              id: "modern_services",
              content: (
                <ModernServicesTable
                  services={services.filter(
                    (service) => service.isModernService
                  )}
                />
              ),
            },
            {
              label: "Others",
              id: "others",
              content: (
                <ModernServicesTable
                  services={services.filter(
                    (service) => !service.isModernService
                  )}
                />
              ),
            },
          ]}
        />
      </SpaceBetween>
    );
  };

  return (
    <SpaceBetween size={"l"}>
      <Container>
        <PathwaysBarChart modernizations={modernizations} services={services} />
      </Container>
      <Container
        header={
          <Header description="Modern Services vs Others">
            Modern Services
          </Header>
        }
      >
        {modernizationServicesContainer()}
      </Container>
    </SpaceBetween>
  );
};

export default ModernizationSection;
